"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

var _typeof3 = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/typeof.js");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/typeof.js"));

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.regexp.split");

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

var _stat = _interopRequireWildcard(require("@/api/stat"));

var _statCust = _interopRequireWildcard(require("@/api/statCust"));

var _vueCountTo = _interopRequireDefault(require("vue-count-to"));

var _vueTreeselect = _interopRequireWildcard(require("@riophae/vue-treeselect"));

var _DateRangePicker = _interopRequireDefault(require("@/components/DateRangePicker"));

var _status = _interopRequireDefault(require("@/api/status"));

require("@riophae/vue-treeselect/dist/vue-treeselect.css");

var _dept = require("@/api/system/dept");

var _user = require("@/api/system/user");

var _vuex = require("vuex");

function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var _default = {
  name: 'Show',
  components: {
    CountTo: _vueCountTo.default,
    DateRangePicker: _DateRangePicker.default,
    Treeselect: _vueTreeselect.default
  },
  dicts: ['cust_msg_from', 'business_from', 'zx_from'],
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['user'])),
  data: function data() {
    return {
      queryStatId: 0,
      deptName: 0,
      filterText: "",
      statTime: [],
      deptUsers: [],
      depts: [],
      tableDatas: [],
      statTables: [],
      statTitles: [],
      currItemLabels: [],
      itemLabels: [],
      cols: [{
        prop: 'id',
        query: 'custIds',
        label: '客户编号',
        width: 150
      }, {
        prop: 'name',
        label: '客户姓名',
        width: 150
      }, {
        prop: 'mobile',
        label: '手机号码',
        width: 150
      }, {
        prop: 'createTime',
        label: '创建时间',
        type: 'date',
        width: 190
      }]
    };
  },
  created: function created() {
    this.deptName = this.user.dept.id;
    this.statTime.push(this.getFirstDay());
    this.statTime.push(this.getLastDay()); // console.log(this.statTime)

    var itemLabels = [];
    itemLabels.push({
      prop: "姓名",
      label: "姓名"
    });
    var that = this;
    (0, _stat.get)({}).then(function (res) {
      that.statTables = res.content;
      res.content.map(function (obj) {
        var items = obj.tabItems.split(",");
        that.statTitles.push({
          label: obj.title
        });
        items.forEach(function (item) {
          var col = {
            prop: item,
            label: item
          };
          itemLabels.push(col);
        });
        that.cols = itemLabels;
      });
    });
    this.getDepts();
  },
  methods: {
    doSearch: function doSearch() {
      var _this = this;

      console.log(this.statTime);
      var that = this;
      var custFrom = this.dict[that.queryItemType];

      if (custFrom) {
        custFrom.forEach(function (obj) {
          setTimeout(function () {
            (0, _statCust.stat)({
              statTime: that.statTime,
              msgFrom: obj.value,
              itemLabels: that.currItemLabels,
              statId: that.queryStatId
            }).then(function (res) {
              console.log(res);
              var items = {};
              var cols = [];
              res.forEach(function (item) {
                var col = {
                  queryItem: {
                    msgFrom: obj.value
                  },
                  prop: item.prop,
                  label: item.prop,
                  format: item.format
                };
                cols.push(col);
                items['queryItem'] = {
                  msgFrom: obj.value
                };
                items[item.prop] = item.value;
              });
              that.cols = cols;
              that.tableDatas.push(items);
            });
          }, 100);
        });
      }

      if (that.queryItemType === 'users') {
        (0, _user.deptUser)(this.deptName, []).then(function (res) {
          var users = res.content;
          that.tableDatas = [];
          var itemLabels = [];
          itemLabels.push({
            prop: "姓名",
            label: "姓名"
          });

          var items = _this.currItemLabels.split(",");

          items.forEach(function (item) {
            itemLabels.push({
              prop: "姓名",
              label: "姓名"
            });
          });
          users.forEach(function (user) {
            setTimeout(function () {
              (0, _statCust.stat)({
                statTime: that.statTime,
                userId: user.id,
                itemLabels: that.currItemLabels,
                statId: that.queryStatId
              }).then(function (res) {
                console.log(res);
                var items = {};
                var cols = [];
                res.forEach(function (item) {
                  var col = {
                    queryItem: {
                      userId: user.id
                    },
                    prop: item.prop,
                    label: item.prop,
                    format: item.format
                  };
                  cols.push(col);
                  items['queryItem'] = {
                    userId: user.id
                  };
                  items[item.prop] = item.value;
                });
                that.cols = cols;
                that.tableDatas.push(items);
              });
            }, 100);
          });
        });
      } else if (that.queryItemType === 'depts') {
        var sort = 'id,desc';
        var params = {
          sort: sort
        };
        params['pid'] = that.deptName;
        var subDepts = [];
        (0, _dept.getDepts)(params).then(function (res) {
          subDepts = res.content;

          if (subDepts.length > 0) {
            subDepts.forEach(function (dept) {
              setTimeout(function () {
                (0, _statCust.stat)({
                  statTime: that.statTime,
                  deptId: dept.id,
                  itemLabels: that.currItemLabels,
                  statId: that.queryStatId
                }).then(function (res) {
                  console.log(res);
                  var items = {};
                  var cols = [];
                  res.forEach(function (item) {
                    var col = {
                      queryItem: {
                        deptId: dept.id
                      },
                      prop: item.prop,
                      label: item.prop,
                      format: item.format
                    };
                    cols.push(col);
                    items['queryItem'] = {
                      deptId: dept.id
                    };
                    items[item.prop] = item.value;
                  });
                  that.cols = cols;
                  that.tableDatas.push(items);
                });
              }, 100);
            });
          } else {
            (0, _statCust.stat)({
              statTime: that.statTime,
              deptId: that.deptName,
              itemLabels: that.currItemLabels
            }).then(function (res) {
              console.log(res);
              var items = {};
              var cols = [];
              res.forEach(function (item) {
                var col = {
                  queryItem: {
                    deptId: that.deptName
                  },
                  prop: item.prop,
                  label: item.prop,
                  format: item.format
                };
                cols.push(col);
                items['queryItem'] = {
                  deptId: that.deptName
                };
                items[item.prop] = item.value;
              });
              that.cols = cols;
              that.tableDatas.push(items);
            });
          }
        });
      }

      console.log(this.deptName);
    },
    toCustList: function toCustList(row, itemLabel) {
      var _this2 = this;

      console.log(row.queryItem);
      var data = row.queryItem;
      console.log(row);
      console.log(itemLabel);
      console.log(this.queryItemType);
      var that = this;
      var custFrom = this.dict[that.queryItemType];

      if (custFrom) {}

      if (that.queryItemType === 'users') {} else if (that.queryItemType === 'depts') {}

      data = Object.assign(data, {
        statTime: that.statTime,
        itemLabels: itemLabel,
        statId: that.queryStatId
      });

      _statCust.default.numCustIds(data).then(function (res) {
        _this2.$router.replace({
          name: 'cms/cust',
          params: {
            custIds: res.value
          }
        });
      });
    },
    // 获取左侧部门数据
    getDeptDatas: function getDeptDatas(node, resolve) {
      var _this3 = this;

      console.log(node);
      var sort = 'id,desc';
      var params = {
        sort: sort
      };

      if ((0, _typeof2.default)(node) !== 'object') {
        if (node) {
          params['name'] = node;
        }
      } else if (node.level !== 0) {
        params['pid'] = node.data.id;
      }

      setTimeout(function () {
        (0, _dept.getDepts)(params).then(function (res) {
          _this3.depts = res.content.map(function (obj) {
            if (obj.hasChildren) {
              obj.children = null;
            }

            return obj;
          });
        });
      }, 100);
    },
    getDepts: function getDepts() {
      var _this4 = this;

      (0, _dept.getDepts)({
        enabled: true
      }).then(function (res) {
        _this4.depts = res.content.map(function (obj) {
          if (obj.hasChildren) {
            obj.children = null;
          }

          return obj;
        });
      });
    },
    // 获取弹窗内部门数据
    loadDepts: function loadDepts(_ref) {
      var action = _ref.action,
          parentNode = _ref.parentNode,
          callback = _ref.callback;

      if (action === _vueTreeselect.LOAD_CHILDREN_OPTIONS) {
        (0, _dept.getDepts)({
          enabled: true,
          pid: parentNode.id
        }).then(function (res) {
          parentNode.children = res.content.map(function (obj) {
            if (obj.hasChildren) {
              obj.children = null;
            }

            return obj;
          });
          setTimeout(function () {
            callback();
          }, 200);
        });
      }
    },
    handleNodeClick: function handleNodeClick(e) {
      var that = this;
      that.cols = [];
      that.tableDatas = [];
      this.statTables.map(function (obj) {
        if (obj.title == e.label) {
          console.log(obj.tabItems);
          that.currItemLabels = obj.tabItems;
          that.queryItemType = obj.queryItemType;
          that.queryStatId = obj.statId;
          that.doSearch();
        }
      });
    },
    getFirstDay: function getFirstDay() {
      //当前月第一天
      var y = new Date().getFullYear(); //获取年份

      var m = new Date().getMonth() + 1; //获取月份

      var d = '01';
      m = m < 10 ? '0' + m : m; //月份补 0

      return [y, m, d].join("-") + " 00:00:00";
    },
    getLastDay: function getLastDay() {
      //当前月最后一天
      var y = new Date().getFullYear(); //获取年份

      var m = new Date().getMonth() + 1; //获取月份

      var d = new Date(y, m, 0).getDate(); //获取当月最后一日

      m = m < 10 ? '0' + m : m; //月份补 0

      d = d < 10 ? '0' + d : d; //日数补 0

      return [y, m, d].join("-") + " 23:59:59";
    }
  }
};
exports.default = _default;